import {Component} from '@angular/core';
import {FooterComponent} from "../footer/footer.component";
import {MenuBarComponent} from "../menu-bar/menu-bar.component";
import {RouterOutlet} from "@angular/router";
import {FlexLayoutModule} from "@ngbracket/ngx-layout";

@Component({
  selector: 'app-layout',
  imports: [
    FooterComponent,
    MenuBarComponent,
    RouterOutlet,
    FlexLayoutModule
  ],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss'
})
export class LayoutComponent {

}
